import Utils from './utils';
import * as keys from './keys';
import ProductConstants from 'constants/ProductConstants';
import isObjectEmpty from 'utils/isObjectEmpty';
import utils from './utils';


const initialDefaults = (formRef, data) => {

  let productData = data?.data
  let biRequest = productData?.bi_request;
  let frequency = biRequest?.INPUT_MODE
  let pt = biRequest?.PR_PT
  let ppt = biRequest?.PR_PPT
  let pt_value = biRequest?.PT_VALUE
  let familyIncomeBenefitOption = biRequest?.FamilyIncomeBenefitOption
  let incomeBenefitPayOutType = biRequest?.IncomeBenefitPayoutType
  let IncomeOption = biRequest?.IncomeOption
  let incomeDuration = biRequest?.IncomeDuration
  let PlanOption = biRequest?.PlanOption
  let Increasing = biRequest?.Increasing
  let Cashback = biRequest?.Cashback
  let TimingofIncomeFromIncomeStartYear = biRequest?.TimingofIncomeFromIncomeStartYear
  let SA_Multiple = biRequest?.PR_SAMF
  let IncomeBenefitPayoutStartYear = biRequest?.IncomeBenefitPayoutStartYear
  let laAge = Number(biRequest?.LI_ENTRY_AGE)
  let cashbackPercentage = biRequest?.FirstPolicyYearofAnnualisedPremium
  let premiumOffsetOption = biRequest?.PremiumOffsetOption
  let premiumOffsetOptionIncomeStartYear = biRequest?.PremiumOffsetOptionIncomeStartYear

  let accrualOfSurvivalBenefits = biRequest?.AccrualOfSurvivalBenefit_1
  let asbStartYearOne = biRequest?.ASB_StartPolicyYear_1
  let asbEndYearOne = biRequest?.ASB_EndPolicyYear_1
  let WithdrawalPercentageOne = biRequest?.WithdrawalPercentage_1
  let isExistingCustomer = biRequest?.IsExistingCustomer
  let isECSMandate = biRequest?.IsECSMandate
  let isIncomeBenefitAdvance = biRequest?.IsIncomeBenefitAdvance

  let deathBenefitOption = biRequest?.DeathBenefitOption
  let sumAssuredonMaturity = biRequest?.SumAssuredonMaturity
  let advantageBenefitPercentage = biRequest?.AdvantageBenefitPercentage
  let incomeBenefitPayoutFrequency = biRequest?.IncomeBenefitPayoutFrequency
  let incomeBenefitPayoutType = biRequest?.IncomeBenefitPayoutType

 let la_age = biRequest?.LI_ENTRY_AGE
 
   if (Number(pt)) {
     formRef.$('PT').set('value', { id: pt, label: pt })
     let list = utils.getPTList(la_age)
     formRef.$("PT").set("extra", {
       ...formRef.$("PT").extra,
       optionList: list
     })
   }

  if (biRequest?.SameProposer) {
    formRef.$('PayorWaiverBenefitRider').set('disabled', true)
  }

  if (Number(incomeBenefitPayoutType)) {
    formRef.$('income-benefit-pay-out-type').set('value', incomeBenefitPayoutType)
  }

  // if (Increasing) {
  //   formRef.$('increasing').set('value', { id: Increasing, label: `${Increasing}%` })
  // }
  // switch (Number(Increasing)) {
  //   case 11:
  //     formRef.$('increasing').set('value', { id: 11, label: "10%" })
  //     break;

  //   case 12:
  //     formRef.$('increasing').set('value', { id: 12, label: "20%" })
  //     break;

  //   case 13:
  //     formRef.$('increasing').set('value', { id: 13, label: "30%" })
  //     break;

  //   case 14:
  //     formRef.$('increasing').set('value', { id: 14, label: "40%" })
  //     break;

  //   case 15:
  //     formRef.$('increasing').set('value', { id: 15, label: "50%" })
  //     break;

  //   case 16:
  //     formRef.$('increasing').set('value', { id: 16, label: "60%" })
  //     break;

  //   case 17:
  //     formRef.$('increasing').set('value', { id: 17, label: "70%" })
  //     break;

  //   case 18:
  //     formRef.$('increasing').set('value', { id: 18, label: "80%" })
  //     break;

  //   case 19:
  //     formRef.$('increasing').set('value', { id: 19, label: "90%" })
  //     break;

  //   case 20:
  //     formRef.$('increasing').set('value', { id: 20, label: "100%" })
  //     break;

  //   default:
  //     break;
  // }

  // switch (Number(cashbackPercentage)) {
  //   case 40:
  //     formRef.$('cashback-percentage').set('value', { id: "40", label: "0%" });
  //     break;

  //   case 41:
  //     formRef.$('cashback-percentage').set('value', { id: "41", label: "5%" });
  //     break;

  //   case 42:
  //     formRef.$('cashback-percentage').set('value', { id: "42", label: "20%" });
  //     break;

  //   case 43:
  //     formRef.$('cashback-percentage').set('value', { id: "43", label: "30%" });
  //     break;

  //   case 44:
  //     formRef.$('cashback-percentage').set('value', { id: "44", label: "40%" });
  //     break;

  //   default:
  //     break;
  // }

  // if (Number(pt)) {
  //   formRef.$('PT').set('value', { id: pt, label: pt })
  // }
  switch (Number(PlanOption)) {
    case 1:
      // let IncomeBenefitPayoutStartYearlist = Utils.PredefinedOptList(1, 21, 14)

      // let defaultValue = Number(IncomeBenefitPayoutStartYear) - 20;
      // formRef.$("income-benefit-payout-start-year").set("extra", {
      //   ...formRef.$("income-benefit-payout-start-year").extra,
      //   isVisible: true,
      //   optionList: [{ id: IncomeBenefitPayoutStartYear, label: defaultValue }]
      // })
      break

    case 2:
      // let IncomeBenefitPayoutStartYearlist2 = Utils.PredefinedOptList(1, 21, Number(ppt))
      // IncomeBenefitPayoutStartYearlist2.push({ id: Number(ppt) + 22 , label: Number(ppt) + 2 })
      // formRef.$("income-benefit-payout-start-year").set("extra", {
      //   ...formRef.$("income-benefit-payout-start-year").extra,
      //   isVisible: true,
      //   optionList: IncomeBenefitPayoutStartYearlist2
      // })

      // if (Number(IncomeBenefitPayoutStartYear)) {
      //   let defaultValue = Number(IncomeBenefitPayoutStartYear) - 20;
      //   formRef.$('income-benefit-payout-start-year').set('value', { id: IncomeBenefitPayoutStartYear, label: defaultValue })

      // }

      break
  }



  // switch (Number(Cashback)) {
  //   case 35:
  //     formRef.$('cashback').set('value', { id: 35, label: 'Yes' })
  //     formRef.$("cashback-percentage").set("extra", {
  //       ...formRef.$("cashback-percentage").extra,
  //       isVisible: true
  //     })
  //     break;

  //   case 36:
  //     formRef.$('cashback').set('value', { id: 36, label: 'No' })
  //     formRef.$("cashback-percentage").set("extra", {
  //       ...formRef.$("cashback-percentage").extra,
  //       isVisible: false
  //     })
  //     break;
  // }


  // switch (Number(TimingofIncomeFromIncomeStartYear)) {
  //   case 37:
  //     formRef.$('timing-of-income-from-income-start-year').set('value', { id: 37, label: 'Start Of Year' })
  //     break;

  //   case 38:
  //     formRef.$('timing-of-income-from-income-start-year').set('value', { id: 38, label: 'End Of Year' })
  //     break;
  // }

  // switch (Number(SA_Multiple)) {
  //   case 5:
  //     formRef.$('sum-assure-multiple').set('value', { id: 5, label: '5' })
  //     break;
  //   case 7:
  //     formRef.$('sum-assure-multiple').set('value', { id: 7, label: '7' })
  //     break;
  //   case 10:
  //     formRef.$('sum-assure-multiple').set('value', { id: 10, label: '10' })
  //     break;
  // }
  //  ! premiumOffsetOption
  // switch (Number(premiumOffsetOption)) {
  //   case 49:
  //     formRef.$('premium-offset-option').set('value', { label: 'Yes', id: 49 });

  //     formRef.$("premium-offset-option-income-start-year").set("extra", {
  //       ...formRef.$("premium-offset-option-income-start-year").extra,
  //       isVisible: true
  //     })
  //     break;

  //   case 50:
  //     formRef.$('premium-offset-option').set('value', { label: 'No', id: 50 });

  //     formRef.$("premium-offset-option-income-start-year").set("extra", {
  //       ...formRef.$("premium-offset-option-income-start-year").extra,
  //       isVisible: false
  //     })
  //     break;

  //   default:
  //     break;
  // }

  // //  ! premiumOffsetOptionIncomeStartYear 
  // switch (Number(premiumOffsetOptionIncomeStartYear)) {
  //   case 51:
  //     formRef.$('premium-offset-option-income-start-year').set('value', { label: '4', id: 51 });
  //     break;

  //   case 52:
  //     formRef.$('premium-offset-option-income-start-year').set('value', { label: '5', id: 52 })

  //     break;

  //   case 53:
  //     formRef.$('premium-offset-option-income-start-year').set('value', { label: '6', id: 53 })
  //     break;

  //   case 54:
  //     formRef.$('premium-offset-option-income-start-year').set('value', { label: '7', id: 54 })
  //     break;

  //   case 55:
  //     formRef.$('premium-offset-option-income-start-year').set('value', { label: '8', id: 55 });
  //     break;

  //   case 56:
  //     formRef.$('premium-offset-option-income-start-year').set('value', { label: '9', id: 56 });
  //     break;

  //   default:
  //     break;
  // }

  // switch (Number(PlanOption)) {
  //   case 1:
  //     formRef.$('plan-option').set('value', { label: 'Lumpsum', id: '1' })
  //     formRef.$('PT').set('value', { id: pt, label: pt })

  //     formRef.$("income-option").set("extra", {
  //       ...formRef.$("income-option").extra,
  //       isVisible: false
  //     })

  //     formRef.$("cashback").set("extra", {
  //       ...formRef.$("cashback").extra,
  //       isVisible: false
  //     })
  //     formRef.$("increasing").set("extra", {
  //       ...formRef.$("increasing").extra,
  //       isVisible: false
  //     })
  //     formRef.$("cashback-percentage").set("extra", {
  //       ...formRef.$("cashback-percentage").extra,
  //       isVisible: false
  //     })
  //     formRef.$("timing-of-income-from-income-start-year").set("extra", {
  //       ...formRef.$("timing-of-income-from-income-start-year").extra,
  //       isVisible: false
  //     })
  //     formRef.$("income-duration").set("extra", {
  //       ...formRef.$("income-duration").extra,
  //       isVisible: false
  //     })
  //     formRef.$("premium-offset-option").set("extra", {
  //       ...formRef.$("premium-offset-option").extra,
  //       isVisible: false
  //     })
  //     formRef.$("premium-offset-option-income-start-year").set("extra", {
  //       ...formRef.$("premium-offset-option-income-start-year").extra,
  //       isVisible: false
  //     })
  //     formRef.$("income-benefit-payout-start-year").set("extra", {
  //       ...formRef.$("income-benefit-payout-start-year").extra,
  //       isVisible: false
  //     })
  //     // let ptlist = []
  //     // if (Number(ppt) >= 5 && Number(ppt) <= 8) {
  //     //   ptlist = Utils.PredefinedOptList(10, 10, 40);
  //     // } else if (Number(ppt) >= 9 && Number(ppt) <= 12) {
  //     //   ptlist = Utils.PredefinedOptList(15, 15, 40);
  //     // }
  //     // formRef.$("PT").set("extra", {
  //     //   ...formRef.$("PT").extra,
  //     //   isVisible: true,
  //     //   optionList: ptlist
  //     // })

  //     formRef.$("sum-assure-multiple").set("extra", {
  //       ...formRef.$("sum-assure-multiple").extra,
  //       isVisible: true,
  //       optionList: [
  //         { id: 5, label: '5' },
  //         { id: 7, label: '7' },
  //         { id: 10, label: '10' },
  //       ]
  //     })

  //     break;

  //   case 2:
  //     formRef.$('plan-option').set('value', { label: 'Income Plus Lumpsum', id: '2' })
  //     // formRef.$('PT').set('disabled', true)
  //     let incomeDurationList = formRef.$('income-duration')?.extra?.optionList
  //     let income_DurationObj = incomeDurationList.find(item => Number(item?.id) === Number(incomeDuration))
  //     // if (!isObjectEmpty(income_DurationObj)) {
  //     //   formRef.$('PT').set('value', { label: Number(income_DurationObj?.label) + Number(ppt) + 1, id: 100 })
  //     // }
  //     if (Number(ppt) >= 5 && Number(ppt) <= 7) {
  //       formRef.$("income-duration").set("extra", {
  //         ...formRef.$("income-duration").extra,
  //         isVisible: true,
  //         optionList: [
  //           { id: 4, label: '15' },
  //           { id: 5, label: '20' },
  //           { id: 6, label: '25' },
  //           { id: 7, label: '30' },
  //           { id: 8, label: '35' },
  //         ]
  //       })
  //     } else if (Number(ppt) >= 8 && Number(ppt) <= 12) {
  //       formRef.$("income-duration").set("extra", {
  //         ...formRef.$("income-duration").extra,
  //         isVisible: true,
  //         optionList: [
  //           { id: 3, label: '10' },
  //           { id: 4, label: '15' },
  //           { id: 5, label: '20' },
  //           { id: 6, label: '25' },
  //           { id: 7, label: '30' }
  //         ]
  //       })
  //     }
  //     let saMultipleList = []
  //     if (Number(laAge) >= 50) {
  //       saMultipleList = [
  //         { id: 5, label: '5' },
  //         { id: 7, label: '7' },
  //         { id: 10, label: '10' },
  //       ]
  //     } else {
  //       saMultipleList = [
  //         { id: 7, label: '7' },
  //         { id: 10, label: '10' },
  //       ]
  //     }

  //     formRef.$("sum-assure-multiple").set("extra", {
  //       ...formRef.$("sum-assure-multiple").extra,
  //       isVisible: true,
  //       optionList: saMultipleList
  //     })
  //     //! enable premium offset option when incomeDuration is 30 and PPT is 12 and cashback is NO 36
  //     if (Number(incomeDuration) === 7 && Number(ppt) === 12 && Number(Cashback) === 36) {
  //       formRef.$("premium-offset-option").set("extra", {
  //         ...formRef.$("premium-offset-option").extra,
  //         isVisible: true
  //       })
  //     }
  //     break;
  // }

  let planOptionlist = utils.getPlanOptionList(Number(pt), Number(ppt))
  formRef.$("plan-option").set("extra", {
    ...formRef.$("plan-option").extra,
    optionList: planOptionlist
  })

  switch (Number(planOption)) {
    case 1:
      formRef.$('plan-option').set('value', { id: 1, label: 'Regular income' })
      formRef.$('sum-assured-on-maturity').set('disabled', false)
      formRef.$('advantage-benefit-percentage').set('disabled', true)
      break;

    case 2:
      formRef.$('plan-option').set('value', { id: 2, label: 'Regular income advantage' })
      formRef.$('sum-assured-on-maturity').set('disabled', true)
      formRef.$('advantage-benefit-percentage').set('disabled', false)
      break;

    default:
      break;
  }




  formRef.$('PPT').value = { id: ppt, label: ppt };
  // ! income option (done)
  switch (Number(IncomeOption)) {
    case 9:
      formRef.$('income-option').set('value', { label: 'Early', id: 9 })
      formRef.$("increasing").set("extra", {
        ...formRef.$("increasing").extra,
        isVisible: false
      })

      formRef.$("timing-of-income-from-income-start-year").set("extra", {
        ...formRef.$("timing-of-income-from-income-start-year").extra,
        optionList: [
          { id: "37", label: 'Start Of Year' },
          { id: "38", label: 'End Of Year' }
        ]
      })

      formRef.$("income-benefit-payout-start-year").set("extra", {
        ...formRef.$("income-benefit-payout-start-year").extra,
        optionList: [
          { id: 21, label: 1 },
          { id: 22, label: 2 },
          { id: 25, label: 5 }
        ]
      })

      if (Number(IncomeBenefitPayoutStartYear)) {
        let defaultValue = Number(IncomeBenefitPayoutStartYear) - 20;
        formRef.$('income-benefit-payout-start-year').set('value', { id: IncomeBenefitPayoutStartYear, label: defaultValue })
      }
      break;

    // case 10:
    //   formRef.$('income-option').set('value', { label: 'Increasing', id: 10 })
    //   break;

    case 45:
      formRef.$('income-option').set('value', { label: 'Deferred', id: 45 })
      formRef.$("timing-of-income-from-income-start-year").set("extra", {
        ...formRef.$("timing-of-income-from-income-start-year").extra,
        optionList: [
          // { id: "37", label: 'Start Of Year' },
          { id: "38", label: 'End Of Year' }
        ]
      })

      if (Number(IncomeBenefitPayoutStartYear)) {
        let defaultValue = Number(IncomeBenefitPayoutStartYear) - 20;
        formRef.$('income-benefit-payout-start-year').set('value', { id: IncomeBenefitPayoutStartYear, label: defaultValue })
        formRef.$("income-benefit-payout-start-year").set("extra", {
          ...formRef.$("income-benefit-payout-start-year").extra,
          optionList: [
            { id: IncomeBenefitPayoutStartYear, label: defaultValue }
          ]
        })
      }
      break;
  }
  //  ! income duration
  switch (incomeDuration) {
    case '3':
      formRef.$('income-duration').set('value', { label: '10', id: '3' });
      break;

    case '4':
      formRef.$('income-duration').set('value', { label: '15', id: '4' })

      break;

    case '5':
      formRef.$('income-duration').set('value', { label: '20', id: '5' })
      break;

    case '6':
      formRef.$('income-duration').set('value', { label: '25', id: '6' })
      break;

    case '7':
      formRef.$('income-duration').set('value', { label: '30', id: '7' });
      break;

    case '8':
      formRef.$('income-duration').set('value', { label: '35', id: '8' });
      break;

    default:
      break;
  }


  // ! payment-frequency/input mode (done)
  switch (frequency?.toString()) {
    case '1':
      formRef.$('payment-frequency').set('value', {
        id: '1',
        label: 'Annual'
      })
      break;
    case '2':
      formRef.$('payment-frequency').set('value', {
        id: '2',
        label: 'Semi-Annual'
      })
      break;
    case '3':
      formRef.$('payment-frequency').set('value', {
        id: '3',
        label: 'Quarterly'
      })
      break;
    case '4':
      formRef.$('payment-frequency').set('value', {
        id: '4',
        label: 'Monthly'
      })
      break;

    default:
      break;
  }
  // ! end of payment-frequency


  // ! family income benefit (done)
  switch (Number(familyIncomeBenefitOption)) {

    case 3:
      formRef.$('family-income-benefit-option').set('value', false)
      break;
    case 4:
      formRef.$('family-income-benefit-option').set('value', true)

      formRef.$('family-income-benefit-option-dropdown').set('value', { label: 'Family Income Benefit on Critical Illness Critical Illness and Death', id: '4' })
      break;
    case 6:
      formRef.$('family-income-benefit-option').set('value', true)

      formRef.$('family-income-benefit-option-dropdown').set('value', { label: 'Family Income Benefit on Death', id: '6' })
      break;

    default:
      break;

  }
  // ! incomeBenefitPayOutType (done)
  // switch (incomeBenefitPayOutType) {

  //   case '5':
  //     formRef.$('income-benefit-pay-out-type').set('value', { label: 'Level', id: '5' })
  //     break;
  //   case '6':
  //     formRef.$('income-benefit-pay-out-type').set('value', { label: 'Increasing', id: '6' })
  //     break;


  //   default:
  //     break;
  // }
  // ! end of incomeBenefitPayOutType

  formRef.$("payment-frequency").set("extra", {
    ...formRef.$("payment-frequency").extra,
    optionList: [
      { label: 'Annual', id: '1' },
      { label: 'Semi-Annual', id: '2' },
      { label: 'Quarterly', id: '3' },
      { label: 'Monthly', id: '4' }
    ],
  })

  switch (Number(isExistingCustomer)) {
    case 1:
      formRef.$('is-existing-customer').set('value', { label: 'Yes', id: isExistingCustomer })
      break;
    case 2:
      formRef.$('is-existing-customer').set('value', { label: 'No', id: isExistingCustomer })
      break;
    default:
      break;
  }

  switch (Number(isECSMandate)) {
    case 1:
      formRef.$('is-ecs-mandate').set('value', { label: 'Yes', id: isECSMandate })
      break;
    case 2:
      formRef.$('is-ecs-mandate').set('value', { label: 'No', id: isECSMandate })
      break;
    default:
      break;
  }

  switch (Number(isIncomeBenefitAdvance)) {
    case 1:
      formRef.$('is-income-benefit-advance').set('value', { label: 'Yes', id: isIncomeBenefitAdvance })
      break;
    case 2:
      formRef.$('is-income-benefit-advance').set('value', { label: 'No', id: isIncomeBenefitAdvance })
      break;
    default:
      break;
  }

  switch (Number(deathBenefitOption)) {
    case 3:
      formRef.$('death-benefit-option').set('value', { label: 'Death Benefit Option 1', id: deathBenefitOption })
      break;
    case 4:
      formRef.$('death-benefit-option').set('value', { label: 'Death Benefit Option 2', id: deathBenefitOption })
      break;
    default:
      break;
  }

  switch (Number(sumAssuredonMaturity)) {
    case 5:
      formRef.$('sum-assured-on-maturity').set('value', { label: 'Option 1', id: sumAssuredonMaturity })
      break;
    case 6:
      formRef.$('sum-assured-on-maturity').set('value', { label: 'Option 2', id: sumAssuredonMaturity })
      break;
    default:
      break;
  }

  switch (Number(incomeBenefitPayoutFrequency)) {
    case 7:
      formRef.$('income-benefit-pay-out-frequency').set('value', {
        id: '7',
        label: 'Annual'
      })
      break;
    case 8:
      formRef.$('income-benefit-pay-out-frequency').set('value', {
        id: '8',
        label: 'Semi-Annual'
      })
      break;
    case 9:
      formRef.$('income-benefit-pay-out-frequency').set('value', {
        id: 9,
        label: 'Quarterly'
      })
      break;
    case 10:
      formRef.$('income-benefit-pay-out-frequency').set('value', {
        id: '10',
        label: 'Monthly'
      })
      break;

    default:
      break;
  }


  switch (Number(advantageBenefitPercentage)) {
    case 11:
      formRef.$('advantage-benefit-percentage').set('value', { label: '40%', id: advantageBenefitPercentage })
      break;
    case 12:
      formRef.$('advantage-benefit-percentage').set('value', { label: '50%', id: advantageBenefitPercentage })
      break;
    default:
      break;
  }



  // !Accrual Of Survival Benefits
  switch (Number(accrualOfSurvivalBenefits)) {
    case 13:
      formRef.$('accrual-of-survival-benefit').set('value', { label: 'Yes', id: "13" })
      break;

    case 14:
      formRef.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "14" })
      break;

    default:
      break;
  }


  // formRef.$("accrual-of-survival-benefits").set("disabled", true);
  utils.handleAsbCondition(formRef, accrualOfSurvivalBenefits)
  // Initial value of ASB Start year 1

  let asbStartYearOneList = utils.fetchASBstartPolicyOne(planOption, pt_value, ppt, formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList, laAge)
  formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
    ...formRef.$("asb-start-age-(1st-opt-in)").extra,
    optionList: asbStartYearOneList,
  });



  let asbStartYearOneOpt = asbStartYearOneList?.filter((item) => Number(asbStartYearOne) === item?.id)
  if (asbStartYearOneOpt?.length > 0) formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneOpt[0])

  // Initial value of ASB End year 1
  let asbEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(1st-opt-in)").value.id, asbStartYearOneList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
  formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
    ...formRef.$("asb-end-age-(1st-opt-in)").extra,
    optionList: asbEndYearOneList,
  });
  let asbEndYearOneOpt = asbEndYearOneList?.filter((item) => Number(asbEndYearOne) === Number(item?.id))
  if (asbEndYearOneOpt?.length > 0) formRef.$("asb-end-age-(1st-opt-in)").set("value", asbEndYearOneOpt[0])

  let asbWithDrawalParcentage1 = formRef.$("withdrawal-parcentage-1").extra.preDefinedOptList
  formRef.$("withdrawal-parcentage-1").set("extra", {
    ...formRef.$("withdrawal-parcentage-1").extra,
    optionList: asbWithDrawalParcentage1,
  });

  let withdrawalPercentage1 = asbWithDrawalParcentage1?.filter((item) => Number(WithdrawalPercentageOne) === Number(item?.id))
  if (withdrawalPercentage1.length > 0) formRef.$("withdrawal-parcentage-1").set("value", withdrawalPercentage1[0])


  if (Number(isIncomeBenefitAdvance) === 1) {
    formRef.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "14" })
    formRef.$('accrual-of-survival-benefit').set('disabled', true)

    utils.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true)
    utils.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true)
    utils.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true)
  } else {
    formRef.$('accrual-of-survival-benefit').set('disabled', false)
  }

  if (biRequest.ADBRider) {
    formRef.$('ADB').set('value', biRequest.ADBRider !== '')
    if (biRequest.ADBRider) {
      formRef.$('ADB-dropdown').set('value', biRequest.ADBRider)
    }
  }
  if (biRequest.ATPDRider) {
    formRef.$('ATPDRider').set('value', biRequest.ATPDRider !== '')
    if (biRequest.ATPDRider) {
      formRef.$('ATPDRider-dropdown').set('value', biRequest.ATPDRider)
    }
  }
  if (biRequest.WaiverOfPremiumRider) {
    formRef.$('WaiverOfPremiumRider').set('value', biRequest.WaiverOfPremiumRider !== '')
  }
  if (biRequest.HospitalityCashBenefitRider) {
    formRef.$('HospitalityCashBenefitRider').set('value', biRequest.HospitalityCashBenefitRider !== '')
    if (biRequest.HospitalityCashBenefitRider) {
      formRef.$('HospitalityCashBenefitRider-dropdown').set('value', biRequest.HospitalityCashBenefitRider)
    }
  }
  if (biRequest.CriticalIllnessRider) {
    formRef.$('CriticalIllnessRider').set('value', biRequest.CriticalIllnessRider !== '')
    if (formRef.$('CriticalIllnessRider').value) {
      formRef.$('CriticalIllnessRider-dropdown').set('value', biRequest.CriticalIllnessRider)
    }
  }
  if (biRequest.PayorWaiverBenefitRider) {
    formRef.$('PayorWaiverBenefitRider').set('value', biRequest.PayorWaiverBenefitRider !== '')
    if (formRef.$('PayorWaiverBenefitRider').value) {
      switch (biRequest.PWB) {
        case '1':
          formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
            id: '1',
            label: 'Option 1 (On Death)'
          })
          break;
        case '2':
          formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
            id: '2',
            label: 'Option 2 (CI or ATPD)'
          })
          break;
        case '3':
          formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
            id: '3',
            label: 'Option 3 (CI or ATPD or Death)'
          })
          break;
        default:
          break;
      }
    }
  }
}

export default initialDefaults